// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"da699809","247":"68f0be47","422":"c18a591c","627":"411f4aa6","828":"d9d6eed5","834":"38fd711e","867":"6518a101","923":"4483006d","938":"4114bc07"}[chunkId] + ".chunk.js";
};